import React from "react";
import Navbar from "./Navbar";
import SearchBar from "./SearchBar";

const Home = () => {
  return (
    <div className="bg-[#fffcfa] ">
      <Navbar />
      <SearchBar />
    </div>
  );
};

export default Home;
